<ndt-device-detail-view
   [device]="device$ | async"
   [devicePrivileges]="devicePrivileges$ | async"
   [callState]="callState$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [selectedAccountName]="selectedAccount$ | async"
   [isOnSystemPage]="isOnSystemPage$ | async"
   (formSaveCanceled)="onFormSaveCanceled()"
   (deleteDevice)="onDeleteDevice($event)"
   (formSubmitted)="onFormSubmitted($event)"
   (deviceReleased)="onDeviceReleased($event)"
   (releaseToAccount)="onReleaseToAccount($event)"
   (resetHackedAndFraud)="onResetHackedAndFraud($event)"
   (rebootPhone)="onRebootPhone($event)"
   (resetPhoneZtp)="onResetPhoneZtp($event)"
></ndt-device-detail-view>
